import { useAsyncFn } from 'react-use';

import { emailPasswordSignUp } from 'supertokens-auth-react/recipe/thirdpartyemailpassword';
import { sendVerificationEmail } from 'supertokens-auth-react/recipe/emailverification';

import { ISignUpRequest } from '../../types/custom-dto.type';

export const useSignUp = () => {
  return useAsyncFn(async (req: ISignUpRequest) => {
    const signUpResponse = await emailPasswordSignUp({
      formFields: Object.entries(req).map(([id, value]) => ({
        id,
        value,
      })),
    });
    if (signUpResponse.status === 'OK') {
      const verificationEmailResponse = await sendVerificationEmail({
        userContext: signUpResponse.user,
      });
      if (verificationEmailResponse.status === 'OK') {
        return signUpResponse.user;
      } else if (
        verificationEmailResponse.status === 'EMAIL_ALREADY_VERIFIED_ERROR'
      ) {
        throw new Error('Email already verified');
      }
    } else if (
      signUpResponse.status === 'FIELD_ERROR' &&
      signUpResponse.formFields
    ) {
      throw new Error(signUpResponse.formFields[0].error);
    }
  });
};
